import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    items: [],
});

export const getters = {
    items: state => state.items,
};

export const mutations = {
    SET_ITEMS(state, items) {
        state.items = cloneDeep(items);
    },

    ADD_ITEM(state, item) {
        const index = state.items.findIndex(i => i.id === item.id);

        if (~index) {
            state.items.splice(index, 1, cloneDeep(item));
        } else {
            state.items.push(cloneDeep(item));
        }
    },

    REMOVE_ITEM(state, id) {
        state.items = state.items.filter(item => item.id !== id);
    }
};

export const actions = {
    async index({ commit }) {
        const items = await axios.$get('/v1/topic_groups');

        commit('SET_ITEMS', items);

        return items;
    },

    async get({ commit }, id) {
        const item = await axios.$get(`/v1/topic_groups/${id}`);

        commit('ADD_ITEM', item);

        return item;
    },

    async create({ commit }, payload) {
        const item = await axios.$post('/v1/topic_groups', payload);

        commit('ADD_ITEM', item);

        return item;
    },

    async update({ commit }, { id, params }) {
        const item = await axios.$put(`/v1/topic_groups/${id}`, params);

        commit('ADD_ITEM', item);

        return item;
    },

    async remove({ commit }, { id, removeTopics }) {
        let params = {};
        if (removeTopics) { params['remove_topics'] = true; }
        await axios.$delete(`/v1/topic_groups/${id}`, { params });
        commit('REMOVE_ITEM', id);
    }
};
